import megafono from "../images/funciones/megafono.png";
import health from "../images/funciones/sw-health.png";
import alert from "../images/funciones/alert.png";
import run from "../images/funciones/run.png";

const funcionalidades = {
  emergencia: {
    image: { megafono },
    title:
      "Ante una emergencia, activá nuestro Botón de Ayuda desde tu celular o desde tu Ellie Watch. ¡Estamos con vos!",
  },
  salud: {
    image: { health },
    title:
      "Con tu Ellie Watch vas a poder medir tu frecuencia cardíaca y tu oxígeno en sange, y si vemos algo que nos llama la atención actuaremos de inmediato.",
  },
  alert: {
    image: { alert },
    title:
      "Cuándo usás tu Ellie Watch, con nuestro algoritmo de detección de caídas, podemos enterarnos automáticamente cuándo si te caés y brindarte asistencia.",
  },
  ejercicio: {
    image: { run },
    title:
      "Es importante mantener un buen ritmo de actividad física para tener músculos fiertes, articulaciones flexibles, ejecticar el equilibrio, y así evitar caídas y accidentes.",
  },
};

export default funcionalidades;
